// src/slices/drawResult/thunk.ts
// Async thunks cho Kết quả Quay số (số trúng thật theo từng kỳ)

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDrawResultByPlanApi, saveDrawResultApi, getIssuancePlansApi } from 'helpers/fakebackend_helper';
import { toast } from 'react-toastify';

// Danh sách kỳ phát hành cho dropdown chọn kỳ (cross-service, chỉ đọc — ticket-service)
export const fetchIssuancePlanOptions = createAsyncThunk(
  'DrawResult/fetchIssuancePlanOptions',
  async (_: void, { rejectWithValue }) => {
    try {
      // PageIndex bắt đầu từ 1 -- quy tắc pagination toàn hệ thống (docs/pagination-rules.md)
      const response = await getIssuancePlansApi({ PageIndex: 1, PageSize: 20 });
      const payload: any = response;
      return payload?.items || payload?.Items || payload || [];
    } catch (error: any) {
      toast.error('Không thể tải danh sách kỳ phát hành');
      return rejectWithValue(error?.response?.data?.message || error?.message);
    }
  }
);

// Kết quả quay số của 1 kỳ đang chọn, theo miền đang chọn trên FE
export const fetchDrawResultByPlan = createAsyncThunk(
  'DrawResult/fetchByPlan',
  async ({ issuancePlanId, region }: { issuancePlanId: number; region: string }, { rejectWithValue }) => {
    try {
      const response = await getDrawResultByPlanApi(issuancePlanId, region);
      return response as any;
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.message || 'Không thể tải kết quả quay số của kỳ này';
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

// Lưu kết quả quay số của 1 kỳ (ghi đè toàn bộ, theo miền)
export const saveDrawResult = createAsyncThunk(
  'DrawResult/save',
  async (
    { issuancePlanId, region, entries }: { issuancePlanId: number; region: string; entries: { prizeTierCode: string; winningNumbers: string[] }[] },
    { rejectWithValue }
  ) => {
    try {
      const response = await saveDrawResultApi(issuancePlanId, { region, entries });
      toast.success('Lưu kết quả quay số thành công.');
      return response as any;
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.message || 'Không thể lưu kết quả quay số';
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);
